interface Props {
  mobile: boolean;
}

const SvgPayment: React.FC<Props> = ({ mobile }) => {
  return (
    <svg
      style={{ transform: mobile ? "" : "scale(1.13)" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9732_41792)">
        <path
          d="M2.83335 3C1.64271 3 0.666687 3.97602 0.666687 5.16667V10.8333C0.666687 12.024 1.64271 13 2.83335 13H13.1667C14.3573 13 15.3334 12.024 15.3334 10.8333V5.16667C15.3334 3.97602 14.3573 3 13.1667 3H2.83335ZM2.83335 4H13.1667C13.8167 4 14.3334 4.51665 14.3334 5.16667V5.66667H1.66669V5.16667C1.66669 4.51665 2.18333 4 2.83335 4ZM1.66669 7H14.3334V10.8333C14.3334 11.4834 13.8167 12 13.1667 12H2.83335C2.18333 12 1.66669 11.4834 1.66669 10.8333V7ZM10.5 9.66667C10.4338 9.66573 10.368 9.67797 10.3065 9.70268C10.245 9.72738 10.1891 9.76406 10.1419 9.81059C10.0947 9.85711 10.0572 9.91255 10.0316 9.97367C10.0061 10.0348 9.9929 10.1004 9.9929 10.1667C9.9929 10.2329 10.0061 10.2985 10.0316 10.3597C10.0572 10.4208 10.0947 10.4762 10.1419 10.5227C10.1891 10.5693 10.245 10.6059 10.3065 10.6307C10.368 10.6554 10.4338 10.6676 10.5 10.6667H12.5C12.5663 10.6676 12.6321 10.6554 12.6935 10.6307C12.755 10.6059 12.811 10.5693 12.8582 10.5227C12.9054 10.4762 12.9428 10.4208 12.9684 10.3597C12.994 10.2985 13.0071 10.2329 13.0071 10.1667C13.0071 10.1004 12.994 10.0348 12.9684 9.97367C12.9428 9.91255 12.9054 9.85711 12.8582 9.81059C12.811 9.76406 12.755 9.72738 12.6935 9.70268C12.6321 9.67797 12.5663 9.66573 12.5 9.66667H10.5Z"
          fill="#262626"
        />
      </g>
      <defs>
        <clipPath id="clip0_9732_41792">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPayment;
